import { fetchEntities } from 'actions/entities'
import ConsultationPrices from 'components/consultation_prices/ConsultationPrices'
import Locations from 'components/locations/Locations'
import pathToRegexp from 'path-to-regexp'
import React from 'react'
import { connect } from 'react-redux'

import { NavLink, Route } from 'react-router-dom'
import { Menu, Tab } from 'semantic-ui-react'
import { getCurrentEmployment } from "../../selectors/employments";
import { getOffices } from "../../selectors/offices";
import CalendarsListContainer from '../calendars/CalendarsListContainer'
import ConsultationReminders from "../email_templates/ConsultationReminders.jsx";
import EmploymentsListContainer from "../employments/EmploymentsListContainer";
import InvoiceConfigurations from "../invoice_configurations/InvoiceConfigurations";
import Templates from "../templates/Templates";
import BasicInfoConfiguration from "./BasicInfoConfiguration";


class Configuration extends React.Component {
  componentDidMount() {
    this.props.fetchEntities();
  }

  render () {
    let firstPaneRoute, firstPaneTitle, firstPane
    if (this.props.view === 'admin') {
      firstPaneRoute = Routes.employments_path()
      firstPaneTitle = I18n.t('components.configuration.employments')
      firstPane =  () => <Tab.Pane basic ><EmploymentsListContainer/></Tab.Pane>

    } else {
      firstPaneRoute = Routes.configuration_path()
      firstPaneTitle = I18n.t('components.configuration.office')
      firstPane = () =>
        <Tab.Pane basic>
          <Route path="/:officeSlug/*" render={(props) => <BasicInfoConfiguration officeId={(this.props.offices.filter( (office) => office.slug === props.match.params.officeSlug )[0] || {}).id} />}/>
        </Tab.Pane>

    }

    const panes = [
      { menuItem: <Menu.Item key={'office'} as={NavLink} to={firstPaneRoute}>{firstPaneTitle}</Menu.Item>, render: firstPane },

      { menuItem: <Menu.Item key={'locations'} as={NavLink} to={Routes.locations_path()}>{I18n.t('components.configuration.locations')}</Menu.Item> , render: () => <Tab.Pane basic ><Locations editable={this.props.configurator}/></Tab.Pane> },


      { menuItem: <Menu.Item key={'calendars'} as={NavLink} to={Routes.calendars_path()}>{I18n.t('components.configuration.calendars')}</Menu.Item>, render: () => <Tab.Pane basic><CalendarsListContainer/></Tab.Pane> },

      { menuItem: <Menu.Item key={'consultationPrices'} as={NavLink} to={Routes.consultation_prices_path()}>{I18n.t('components.configuration.consultation_prices')}</Menu.Item> , render: () => <Tab.Pane basic ><ConsultationPrices editable={this.props.configurator}/></Tab.Pane> },

      { menuItem: <Menu.Item key={'emailTemplates'} as={NavLink} to={Routes.consultation_reminders_path()}>{I18n.t('components.configuration.email_templates')}</Menu.Item> , render: () => <Tab.Pane basic ><ConsultationReminders/></Tab.Pane> },

      { menuItem: <Menu.Item key={'invoiceConfiguration'} as={NavLink} to={Routes.invoice_configurations_path()}>{I18n.t('components.configuration.invoice_configuration')}</Menu.Item>, render: () => <Tab.Pane basic><InvoiceConfigurations/></Tab.Pane> },

      { menuItem: <Menu.Item key={'templates'} as={NavLink} to={Routes.templates_path()}>{I18n.t('components.configuration.templates')}</Menu.Item>, render: () => <Tab.Pane basic><Templates/></Tab.Pane>}]

    return (
      <Route path={"/:officeSlug/*"} render={(props) => {
        var activeIndex = 0
        if (pathToRegexp(firstPaneRoute).exec(props.match.url)) {
          activeIndex = 0
        } else if (pathToRegexp(Routes.locations_path()).exec(props.match.url) || pathToRegexp(Routes.location_path({ id: ":id", _options: true })).exec(props.match.url)) {
          activeIndex = 1
        } else if (pathToRegexp(Routes.calendars_path()).exec(props.match.url)) {
          activeIndex = 2
        } else if (pathToRegexp(Routes.consultation_prices_path()).exec(props.match.url)) {
          activeIndex = 3
        } else if (pathToRegexp(Routes.consultation_reminders_path()).exec(props.match.url) || pathToRegexp(Routes.consultation_reminder_path({ id: ":id", _options: true })).exec(props.match.url)) {
          activeIndex = 4
        } else if (pathToRegexp(Routes.invoice_configurations_path()).exec(props.match.url) || pathToRegexp(Routes.invoice_configuration_path({ id: ":id", _options: true })).exec(props.match.url)) {
          activeIndex = 5
        } else if (pathToRegexp(Routes.templates_path()).exec(props.match.url)) {
          activeIndex = 6
        }

        return <Tab activeIndex={activeIndex}  menu={{secondary: true, pointing: true}} panes={panes}/>}
      }/>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const current = getCurrentEmployment(state)
  return {
    offices: getOffices(state),
    loading: state.meta?.office?.loading,
    configurator: current && current.roles.includes('configurator'),
    view: state.view
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('offices'))
      dispatch(fetchEntities('teams'))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Configuration);
